module.exports = __webpack_public_path__ + "b7afc5ad825bbdbafb4245a4d0fdaebb.svg";


//////////////////
// WEBPACK FOOTER
// ./images/back-button2.svg
// module id = 87
// module chunks = 0